<template>
  <section :class="['row', 'row--inverted', {'row--slidup': isInView}]">
    <header class="row__header">
      <h2 class="row__title row__title--small">
        Skorzy&shy;staj z Caredo
      </h2>
      <p class="row__subtitle">
        Popraw wydajność swojej firmy
      </p>
    </header>
  </section>
</template>

<script>
export default {
  name: 'use-element',
};
</script>

<style lang="scss" scoped>

</style>
